export default __webpack_public_path__ + "static/media/pencil-icon.2623daed.svg";